
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tyres/van/overlanding",
      function () {
        return require("private-next-pages/tyres/van/overlanding.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tyres/van/overlanding"])
      });
    }
  